import { RoutePath, type RoutePaths } from "@/lib/routes"
import { type OnboardingRouteNames } from "./onboarding-route-names"

export enum EnergyTypeRoutes {
    Electricity = "électricité",
    Gas = "gaz",
}

export const onboardingRoutesPaths = {
    addressIneligible: RoutePath.create("/souscription/adresse-ineligible"),
    confirmation: RoutePath.create("/souscription/confirmation"),
    electricityMeterIneligible: RoutePath.create("/souscription/ineligible"),
    energyLandscape: RoutePath.create("/souscription/paysage-energetique"),
    prePayment: RoutePath.create("/souscription/informations-de-paiement/premiere-mensualite"),
    prePaymentCdf: RoutePath.create(
        "/souscription/informations-de-paiement/premiere-mensualite-cdf"
    ),
    gasMeterIneligible: RoutePath.create("/souscription/pce-ineligible"),
    meterDetails: RoutePath.create("/souscription"),
    meterDetailsWithDetails: RoutePath.create(
        "/souscription?electricityMeterPointId=:electricityMeterPointId&givenName=:givenName&familyName=:familyName"
    ),
    meterDetailsWithAffiliate: RoutePath.create("/souscription?affiliate=:affiliateCode"),
    meterDetailsWithPartner: RoutePath.create("/souscription/:partnerSlug"),
    meterDetailsMonoEnergy: RoutePath.create(
        "/souscription/energie/:energyType?propertyId=:propertyId"
    ),
    meterReadings: RoutePath.create("/souscription/autoreleve"),
    moveOut: RoutePath.create("/souscription/je-demenage?accountNumber=:accountNumber"),
    moveOutIneligible: RoutePath.create("/souscription/erreur-demenagement"),
    moveOutMeterDetails: RoutePath.create("/souscription/nouveau-logement"),
    onboarded: RoutePath.create("/souscription/bienvenue"),
    orderReview: RoutePath.create("/souscription/resume-de-commande"),
    paymentDetails: RoutePath.create("/souscription/informations-de-paiement"),
    paymentDetailsConsent: RoutePath.create("/souscription/informations-de-paiement/consentement"),
    paymentDetailsErrorConsent: RoutePath.create(
        "/souscription/informations-de-paiement/erreur-consentement"
    ),
    paymentDetailsErrorIban: RoutePath.create(
        "/souscription/informations-de-paiement/erreur-paiement-cn"
    ),
    paymentDetailsErrorPrepayment: RoutePath.create(
        "/souscription/informations-de-paiement/erreur-prepaiement"
    ),
    paymentDetailsErrorSignature: RoutePath.create(
        "/souscription/informations-de-paiement/erreur-signature"
    ),
    paymentDetailsFinancialSituation: RoutePath.create(
        "/souscription/informations-de-paiement/situation-financiere"
    ),
    paymentDetailsFinancialSituationSuccess: RoutePath.create(
        "/souscription/informations-de-paiement/situation-financiere-succes"
    ),
    paymentDetailsPendingPrepayment: RoutePath.create(
        "/souscription/informations-de-paiement/attente-confirmation-paiement"
    ),
    paymentDetailsRetry: RoutePath.create("/souscription/informations-de-paiement/erreur"),
    paymentDetailsSuccess: RoutePath.create("/souscription/informations-de-paiement/succes"),
    paymentDetailsUnpaidBills: RoutePath.create(
        "/souscription/informations-de-paiement/erreur-paiement"
    ),
    personalDetails: RoutePath.create("/souscription/informations-personnelles"),
    providerCalendar: RoutePath.create("/souscription/option-tarifaire"),
    quote: RoutePath.create("/souscription/devis"),
    securityDeposit: RoutePath.create("/souscription/depot-de-garantie"),
} as const satisfies RoutePaths<OnboardingRouteNames>
